import * as React from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { DamsSelectInputProps } from ".";
import {
  Avatar,
  CircularProgress,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { DamsAppAsset } from "../../assets/registry";
import { useState } from "react";
import { DamsColors } from "../styles/DamsColors";

export function ItemSelectInput({
  item,
  size = "short",
  items,
  label,
  placeholder,
  handleChange,
  name,
  value,
  error,
  errorMessage,
  loading,
  required = false,
}: Readonly<DamsSelectInputProps>) {
  const [open, setOpen] = useState(false);

  const handleToggle = () => {
    if (!loading) {
      setOpen(!open);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const InputSize =
    size === "long"
      ? { width: 512, height: 75 }
      : size === "full"
        ? { width: "100%", height: 75 }
        : { width: 260, height: 75 };

  const isAvailable = items.find((item) => item.value === value);
  const renderValue = (selectedValue: any) => {
    if (!selectedValue) {
      return <Typography color="gray">{placeholder}</Typography>;
    }

    // Display the value regardless of whether it's in the items list
    return selectedValue;
  };
  // Always use the provided value, even if not in items list yet
  const inputValue = value || "";

  return (
    <Stack width={InputSize.width} height={InputSize.height} gap={0.3}>
      {label && (
        <Typography
          fontFamily={"Inter"}
          fontWeight={500}
          fontSize={14}
          color={DamsColors.Text.PageLabel}
        >
          {label}
          {required && (
            <span style={{ color: "red", marginLeft: "4px" }}>*</span>
          )}
        </Typography>
      )}

      <FormControl>
        <Select
          name={name}
          value={inputValue}
          open={open}
          onChange={handleChange}
          defaultValue=""
          onClose={handleClose}
          onClick={handleToggle}
          displayEmpty
          renderValue={renderValue}
          IconComponent={CustomEmptyIcon}
          required={required}
          endAdornment={
            <IconButton onClick={handleToggle}>
              {loading ? (
                <CircularProgress size={15} />
              ) : (
                <Avatar
                  src={DamsAppAsset.icons.select_arrow}
                  sx={selectStyles.arrowDownIcon}
                />
              )}
            </IconButton>
          }
          sx={selectStyles.selectInput}
        >
          {items.map((data, index) => (
            <MenuItem value={data.value} key={`${index}`}>
              <Typography
                fontFamily={"Inter"}
                fontWeight={400}
                fontSize={16}
                color={"#667085"}
              >
                {data.label}
              </Typography>
            </MenuItem>
          ))}
        </Select>
        {error && (
          <Typography variant="caption" color={"red"} sx={{ marginLeft: 1 }}>
            {errorMessage}
          </Typography>
        )}
      </FormControl>
    </Stack>
  );
}

const CustomEmptyIcon = () => null;

const selectStyles = {
  arrowDownIcon: {
    width: "20px",
    height: "20px",
  },
  selectInput: {
    borderRadius: "8px",
    borderColor: `${DamsColors.Border.PageInput} !important`,
    "& .MuiSelect-select": {
      borderRadius: "8px",
      color: "#667085",
      backgroundColor: "white",
      "&:focus": {
        borderRadius: "8px",
        borderColor: `${DamsColors.Border.PageInput} !important`,
      },
      "&:hover": {
        borderRadius: "8px",
        borderColor: `${DamsColors.Border.PageInput} !important`,
      },
      "&:active": {
        borderRadius: "8px",
        borderColor: `${DamsColors.Border.PageInput} !important`,
      },
      borderColor: `${DamsColors.Border.PageInput} !important`,
    },
    "&.Mui-focused fieldset": {
      borderColor: `${DamsColors.Border.PageInput} !important`,
      borderRadius: "8px",
    },
    "&:hover fieldset": {
      borderColor: `${DamsColors.Border.PageInput} !important`,
      borderRadius: "8px",
    },
  },
};

export default ItemSelectInput;
